import PermissionDenied from '@/components/PermissionDenied';

export default function UnauthorizedPage() {
  return <PermissionDenied />;
}
